import React, { useState } from 'react';
import { useEmailSubscription } from '../../hooks/useEmailSubscription';
import './Hero.css';

const Hero = () => {
  const [email, setEmail] = useState('');
  const { subscribe, isLoading } = useEmailSubscription();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await subscribe(email);
    if (result.success) {
      setEmail('');
    }
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-badge">
          <span className="hero-badge-dot" />
          <span className="hero-badge-text">Accountable Renting for Landlords and Residents.</span>
        </div>

        <h1 className="hero-title">
          <span className="hero-title-line">Because renters</span>
          <span className="hero-title-line">deserve better.</span>
          <span className="hero-title-line hero-title-accent">RentWise.</span>
        </h1>

        <p className="hero-description">
          RentWise gives renters the tools to organize, document, and protect
          themselves — so you never lose another dollar to an unfair landlord.
        </p>

        <form className="hero-form" onSubmit={handleSubmit} id="waitlist">
          <input
            type="email"
            className="hero-email-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
          <button type="submit" className="hero-submit-btn" disabled={isLoading}>
            {isLoading ? 'Joining...' : 'Join the Movement'}
          </button>
        </form>

        <p className="hero-footnote">
          Join thousands of renters demanding better. Be first in line.
        </p>
      </div>
    </section>
  );
};

export default Hero;
